import {
  DEFAULT_WARNING_TIMEOUT,
  SHOW_WARNING_DIALOG_LOCAL_STORAGE_KEY,
} from "./constants";

export const getShowWarningDialogItemFromLocalStorage = () =>
  localStorage.getItem(SHOW_WARNING_DIALOG_LOCAL_STORAGE_KEY);

export const setShowWarningDialogItemToLocalStorage = () => {
  localStorage.setItem(
    SHOW_WARNING_DIALOG_LOCAL_STORAGE_KEY,
    String(Date.now() + DEFAULT_WARNING_TIMEOUT)
  );
};

export const removeShowWarningDialogItemFromLocalStorage = () => {
  localStorage.removeItem(SHOW_WARNING_DIALOG_LOCAL_STORAGE_KEY);
};
